<script setup>
import { Link } from '@inertiajs/vue3'
import { useNotificationsStore } from '@/Stores/notifications'

const notificationsStore = useNotificationsStore()

defineProps({
    notification: Object
})
</script>

<template>
    <Link
        :href="`${notification.data.commentable.url}?comment=${notification.data.comment_id}`"
        v-on:click="notificationsStore.panelOpen = false"
    >
        A new comment was posted by {{ notification.data.username }} in <span class="text-[rgba(233,232,255,1)]">{{ notification.data.commentable.title }}</span>
    </Link>
</template>
